"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkTypeIntermediate = 'C';
exports.ChunkTypeFinal = 'F';
exports.ChunkTypeError = 'A';
